export const ROUTE_LOGIN = '/login';
export const ROUTE_LOGIN_VERIFY = '/login/verify';
export const ROUTE_LOGIN_BLOCKED = '/login/blocked';
export const ROUTE_FORGOT_PASSWORD = '/forgot-password';
export const ROUTE_FORGOT_PASSWORD_VERIFY = '/forgot-password/verify';
export const ROUTE_SET_NEW_PASSWORD = '/set-new-password';
export const ROUTE_INVITATION_UNSUBSCRIBE = '/invitation/unsubscribe';

// ADMIN routes

// ETZ Profile
export const ROUTE_ETZ_PROFILE = '/etz-profile';
export const ROUTE_ETZ_PROFILE_TRANSACTIONS = '/etz-profile/transactions';
export const ROUTE_ETZ_PROFILE_ASSETS = '/etz-profile/assets';
export const ROUTE_ETZ_PROFILE_REVENUE = '/etz-profile/revenue';
export const ROUTE_ETZ_PROFILE_INFLOW_OUTFLOW = '/etz-profile/inflow-outflow';

// Employers
export const ROUTE_EMPLOYERS = '/employers';
export const ROUTE_IRA_USERS_ADMIN = '/employers/:employerId/employees';
export const ROUTE_NEW_IRAUSER_ADMIN = '/employers/:employerId/employees/new';
export const ROUTE_INFO_IRAUSER_ADMIN =
  '/employers/:employerId/employees/:iraUserId/general-info';
export const ROUTE_INFO_IRAUSER_TRANSACTIONS =
  '/employers/:employerId/employees/:iraUserId/transactions';
export const ROUTE_INFO_IRAUSER_OPEN_ORDERS =
  '/employers/:employerId/employees/:iraUserId/open-orders';
export const ROUTE_INFO_IRAUSER_ASSETS =
  '/employers/:employerId/employees/:iraUserId/assets';

// IRA accounts
export const ROUTE_IRA_ACCOUNTS_NEW = '/ira-accounts/new';
export const ROUTE_IRA_ACCOUNTS = '/ira-accounts';
export const ROUTE_IRA_ACCOUNTS_GENERAL_INFO =
  '/ira-accounts/:independentIraUserId/general-info';
export const ROUTE_IRA_ACCOUNTS_TRANSACTIONS =
  '/ira-accounts/:independentIraUserId/transactions';
export const ROUTE_IRA_ACCOUNTS_OPEN_ORDERS =
  '/ira-accounts/:independentIraUserId/open-orders';
export const ROUTE_IRA_ACCOUNTS_ASSETS = '/ira-accounts/:independentIraUserId/assets';
export const ROUTE_IRA_ACCOUNTS_IRA_USER_GENERAL_INFO =
  '/ira-accounts/ira-user/:iraUserId/general-info'; // rerouting
export const ROUTE_IRA_ACCOUNTS_IRA_USER_TRANSACTIONS =
  '/ira-accounts/ira-user/:iraUserId/transactions'; // rerouting
export const ROUTE_IRA_ACCOUNTS_IRA_USER_OPEN_ORDERS =
  '/ira-accounts/ira-user/:iraUserId/open-orders'; // rerouting
export const ROUTE_IRA_ACCOUNTS_IRA_USER_ASSETS =
  '/ira-accounts/ira-user/:iraUserId/assets'; // rerouting

// Contributions
export const ROUTE_CONTRIBUTIONS = '/contributions';
export const ROUTE_CONTRIBUTION_DETAILS = '/contributions/:contributionId/details';
export const ROUTE_CONTRIBUTION_DETAIL_IRA_USER =
  '/contributions/:contributionId/details/ira-user/:iraUserId/general-info'; // rerouting
export const ROUTE_CONTRIBUTION_DETAIL_IRA_USER_TRANSACTIONS =
  '/contributions/:contributionId/details/ira-user/:iraUserId/transactions'; // rerouting
export const ROUTE_CONTRIBUTION_DETAIL_IRA_USER_OPEN_ORDERS =
  '/contributions/:contributionId/details/ira-user/:iraUserId/open-orders'; // rerouting
export const ROUTE_CONTRIBUTION_DETAIL_IRA_USER_ASSETS =
  '/contributions/:contributionId/details/ira-user/:iraUserId/assets'; // rerouting
export const ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT =
  '/contributions/:contributionId/details/ira-account/:independentIraUserId/general-info'; // rerouting
export const ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_TRANSACTIONS =
  '/contributions/:contributionId/details/ira-account/:independentIraUserId/transactions'; // rerouting
export const ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_OPEN_ORDERS =
  '/contributions/:contributionId/details/ira-account/:independentIraUserId/open-orders'; // rerouting
export const ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_ASSETS =
  '/contributions/:contributionId/details/ira-account/:independentIraUserId/assets'; // rerouting

// All roles
export const ROUTE_SETTINGS = '/settings';

// USER routes
// NOTE: Disabled in ETZ-2825. Need to check actuality. Related to 'Role User'
// export const ROUTE_AUTH_USERS_USER = '/auth-users';
// export const ROUTE_IRA_USERS_USER = '/employees';
// export const ROUTE_NEW_IRAUSER_USER = '/employees/new';
// export const ROUTE_INFO_IRAUSER_USER = '/employees/:iraUserId/general-info';
// export const ROUTE_DOCUMENTS = '/documents';
